"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_1 = require("./event-polyfills/event");
exports.Event = event_1.default;
var focus_event_1 = require("./event-polyfills/focus-event");
exports.FocusEvent = focus_event_1.default;
var input_event_1 = require("./event-polyfills/input-event");
exports.InputEvent = input_event_1.default;
var keyboard_event_1 = require("./event-polyfills/keyboard-event");
exports.KeyboardEvent = keyboard_event_1.default;
var mouse_event_1 = require("./event-polyfills/mouse-event");
exports.MouseEvent = mouse_event_1.default;
var AwsUiComponent = /** @class */ (function () {
    function AwsUiComponent() {
    }
    return AwsUiComponent;
}());
exports.AwsUiComponent = AwsUiComponent;
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["space"] = 32] = "space";
    KeyCode[KeyCode["down"] = 40] = "down";
    KeyCode[KeyCode["left"] = 37] = "left";
    KeyCode[KeyCode["right"] = 39] = "right";
    KeyCode[KeyCode["up"] = 38] = "up";
    KeyCode[KeyCode["escape"] = 27] = "escape";
    KeyCode[KeyCode["enter"] = 13] = "enter";
    KeyCode[KeyCode["tab"] = 9] = "tab";
    KeyCode[KeyCode["shift"] = 16] = "shift";
    KeyCode[KeyCode["backspace"] = 8] = "backspace";
})(KeyCode = exports.KeyCode || (exports.KeyCode = {}));
// Used as decorator to mark dom-only methods in test-utils
exports.usesDom = function () { };
var AbstractWrapper = /** @class */ (function () {
    function AbstractWrapper(element) {
        this.element = element;
    }
    AbstractWrapper.prototype.getElement = function () {
        return this.element;
    };
    /**
     * Performs a click by triggering a mouse event.
     * Note that programmatic events ignore disabled attribute and will trigger listeners even if the element is disabled.
     */
    AbstractWrapper.prototype.click = function (params) {
        this.fireEvent(new mouse_event_1.default('click', params));
    };
    AbstractWrapper.prototype.keydown = function (args) {
        if (typeof args === 'object') {
            this.fireEvent(new keyboard_event_1.default('keydown', args));
        }
        else {
            this.fireEvent(new keyboard_event_1.default('keydown', { keyCode: args }));
        }
    };
    AbstractWrapper.prototype.keyup = function (keyCode) {
        this.fireEvent(new keyboard_event_1.default('keyup', { keyCode: keyCode }));
    };
    AbstractWrapper.prototype.fireEvent = function (event) {
        this.element.dispatchEvent(event);
    };
    AbstractWrapper.prototype.focus = function () {
        this.element.focus();
    };
    AbstractWrapper.prototype.blur = function () {
        this.element.blur();
    };
    AbstractWrapper.prototype.find = function (selector) {
        return this.findAll(selector)[0] || null;
    };
    AbstractWrapper.prototype.findAll = function (selector) {
        var elements = Array.prototype.slice.call(this.element.querySelectorAll(selector));
        return elements.map(function (element) { return new ElementWrapper(element); });
    };
    AbstractWrapper.prototype.findComponent = function (selector, ComponentClass) {
        var elementWrapper = this.find(selector);
        return elementWrapper ? new ComponentClass(elementWrapper.getElement()) : null;
    };
    return AbstractWrapper;
}());
exports.AbstractWrapper = AbstractWrapper;
var ElementWrapper = /** @class */ (function (_super) {
    __extends(ElementWrapper, _super);
    function ElementWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ElementWrapper;
}(AbstractWrapper));
exports.ElementWrapper = ElementWrapper;
var ComponentWrapper = /** @class */ (function (_super) {
    __extends(ComponentWrapper, _super);
    function ComponentWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComponentWrapper.prototype.getComponent = function () {
        return this.element.component;
    };
    return ComponentWrapper;
}(AbstractWrapper));
exports.ComponentWrapper = ComponentWrapper;
//# sourceMappingURL=dom.js.map